import React, { useState, useEffect, useRef } from "react";
import "./index.less";
import { Button, message, Modal, Pagination, Tabs } from 'antd';
import { request } from "@/utils/request"
import Config from "@/config/config";
import { formatTimestampToDate, getCountdownMinutesSeconds } from "@/utils/func";
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { APPOINTMENT_STATUS, APPOINTMENT_STATUS_NAME, GOOD_ORDER_STATUS, GOOD_ORDER_STATUS_NAME, ORDER_STATUS, ORDER_STATUS_NAME, PAYMENT_STATUS, REFOUND_AMOUNT_STATUS, REFOUND_AMOUNT_STATUS_NAME, REFOUND_DEPOSIT_STATUS, REFOUND_DEPOSIT_STATUS_NAME } from "@/constant";
import { useLocation, useNavigate } from "react-router-dom";

export default function TransferOrderDetail() {
    const navigate = useNavigate();
    const [info, setInfo] = useState()
    const [orderDetail, setOrderDetail] = useState({});
    const timeRef = useRef(null)
    const [time, setTime] = useState('')
    const queryParams = new URLSearchParams(window.location.search);
    const getOrderDetail = () => {
        request.get(`goodseat_order/detail?id=${queryParams.get('id')}`).then(res => {
            setOrderDetail(res.data);
            if (res.data.order_status == 1&& res.data?.sub_status != GOOD_ORDER_STATUS.in_the_draw && res.data?.sub_status != GOOD_ORDER_STATUS.not_winning) {
                timeRef.current = setInterval(() => {
                    setTime(getCountdownMinutesSeconds(res.data.created_at))
                }, 1000);
            }
            if (res.data.order_status == 1 && res.data?.lucky == 1 && res.data?.sub_status == GOOD_ORDER_STATUS.paying) {
                timeRef.current = setInterval(() => {
                  setTime(getCountdownMinutesSeconds(res.data.will_cancel_at,false))
                }, 1000);
              }
        })
    }
   
    useEffect(() => {
        getOrderDetail();
        return (() => {
            timeRef.current = null
            clearInterval(timeRef.current)
        })
    }, [])
    const sureCancel = () => {
        request.post('goodseat_order/cancel', { id: orderDetail?.id }).then(r => {
            message.success('取消成功')
            setTimeout(() => {
                getOrderDetail()
            }, 500)
        })
    }
    const sureDel = () => {
        request.post('goodseat_order/delete', { id: orderDetail?.id }).then(r => {
            message.success('删除成功')
            setTimeout(() => {
                navigate(-1)
            }, 500)
        })
    }


    const [modalCancel, contextHolderCancel] = Modal.useModal();
    const confirmCancel = () => {
        modalCancel.confirm({
            title: '取消预约',
            icon: <ExclamationCircleOutlined />,
            content: '您确定要取消预约吗',
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
                sureCancel()
            },
            maskClosable:true,
        });
    };
    const [delCancel, contextHolderDel] = Modal.useModal();
    const confirmDel = () => {
        delCancel.confirm({
            title: '删除订单',
            icon: <ExclamationCircleOutlined />,
            content: '您确定要删除吗',
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
                sureDel()
            },
            maskClosable:true,
        });
    };
    const submitPay = (order_no) => {
        navigate('/pay?sn=' + order_no+'&id='+orderDetail.id+'&type=1&from=orderDetail')
    }
    return (
        <div className="order">
            <div className="order-detail-content">
                <Button type="cancel" style={{ with: "74px", height: "32px", color: "#999999", borderRadius: "4px" }}
                    onClick={() => navigate(-1)}>
                    返回
                </Button>
                <div className="order-status"> {GOOD_ORDER_STATUS_NAME[orderDetail?.sub_status]?.name}</div>
                {
                    (orderDetail?.order_status === ORDER_STATUS.waitPay && orderDetail?.sub_status != GOOD_ORDER_STATUS.in_the_draw)
                        ? <div className="pay-time">剩余支付时间
                            <span style={{ marginLeft: '10px' }}>{time}</span>
                        </div> : <div className="statusTips">{orderDetail?.refund_remark || GOOD_ORDER_STATUS_NAME[orderDetail.sub_status]?.tip}</div>
                }
                <div className="sub-time">
                    <div className="sub-name">{orderDetail?.good_seat_resp?.name}</div>
                    <div className="sub-info">
                        <div className="sub-item" >
                            <div className="label">预约时间：</div>
                            <div>{orderDetail?.good_seat_resp?.reservation_date_confirm&&formatTimestampToDate(orderDetail?.good_seat_resp?.reservation_date_confirm)} {orderDetail?.good_seat_resp?.reservation_time_confirm||''}</div>
                        </div>
                        <div className="sub-item" >
                            <div className="label">预订数量：</div>
                            <div>{orderDetail?.buy_seats_amount||0}</div>
                        </div>

                    </div>
                </div>
                {
                    orderDetail?.order_status !== ORDER_STATUS.waitPay && orderDetail?.order_status !== ORDER_STATUS.notTransacted &&
                    <div className="sub-time">
                        <div className="sub-name">就餐预约信息</div>
                        <div className="sub-info">
                            <div className="sub-item" dangerouslySetInnerHTML={{__html:orderDetail?.good_seat_resp?.reservation_details?.replace(/ /g, '&nbsp;').replace(/\n|↵/g, '<br/>')}} >
                            </div>
                           
                        </div>
                    </div>
                }

                <div className="sub-time">
                    <div className="sub-name">订位费用</div>
                    <div className="sub-info">
                        <div className="sub-item" >
                            <div className="label">预约费：</div>
                            <div>￥{orderDetail?.good_seat_resp?.subscription_price} x{orderDetail?.buy_seats_amount}</div>
                        </div>
                        <div className="sub-item" >
                            <div className="label">套餐押金：</div>
                            <div style={{flex:'none'}}>￥{orderDetail?.good_seat_resp?.meal_deposit} x{orderDetail?.buy_seats_amount}</div>
                            <div style={{color:'#ea0025'}}>（押金不抵扣餐费，用餐后点击“就餐完成”，上传账单小票退款）</div>
                        </div>
                        <div className="sub-item" >
                            <div className="label">总计：</div>
                            <div>￥{orderDetail?.reservation_total_amount&&(orderDetail?.reservation_total_amount * 1).toFixed(2)||0}</div>
                        </div>

                    </div>
                </div>
                <div className="sub-tip">
                    <div className="sub-tip-tit">购买须知:</div>
                    <div className="sub-tip-desc-text" dangerouslySetInnerHTML={{__html:orderDetail?.good_seat_resp?.shopping_notice?.replace(/ /g, '&nbsp;').replace(/\n|↵/g, '<br/>')}}>
                        
                    </div>
                </div>

            </div>
            <div className="order-tool">
                {
                    orderDetail?.order_status === ORDER_STATUS.waitPay && orderDetail?.sub_status != GOOD_ORDER_STATUS.in_the_draw &&
                    <div className="order-tool-content">
                        <div className="order-tool-amount">￥{orderDetail?.reservation_total_amount * 1}</div>
                        <div className="order-btns">
                            <div className="order-btns-gray" onClick={confirmCancel}>取消预约</div>
                            {contextHolderCancel}
                            <div className="order-btns-active" onClick={()=>submitPay(orderDetail?.order_no)}>立即支付</div>
                        </div>
                    </div>
                }
                {
                    // 取消预约订单
                    (orderDetail?.order_status === ORDER_STATUS.notTransacted
                        || (orderDetail?.order_status === ORDER_STATUS.completed && (orderDetail?.sub_status == GOOD_ORDER_STATUS.refound_success||orderDetail?.sub_status==GOOD_ORDER_STATUS.refound_fail)))
                    &&
                    <div className="order-tool-content">
                        {/* 删除 */}
                        <div></div>
                        <div className="order-btns">
                            <div className="order-btns-gray" onClick={confirmDel}>删除订单</div>
                            {contextHolderDel}
                        </div>
                    </div>
                }
                {
                    orderDetail.order_status == ORDER_STATUS.tobeUsed &&
                    <div className="order-tool-content">
                        {/* 预约成功 */}
                        <div></div>
                        <div className="order-btns">

                            <div className="order-btns-active" onClick={() => {
                                navigate(`/diningCompleted?id=${orderDetail?.id}&type=2`,)
                            }}>就餐完成</div>
                        </div>
                    </div>
                }
            </div>

        </div>

    );

}

